import { resolveInitialTheme } from './theme-utils';

export const initialState = { theme: resolveInitialTheme() };

export const reducer = (state, action) => {
  switch (action.type) {
    case 'toggle':
      return { ...state, theme: state.theme === 'dark' ? 'light' : 'dark' };
    case 'set':
      return { ...state, theme: action.payload };
    default:
      return state;
  }
};
